export { default as ArrowBack } from '#/images/svg/arrow-back.svg'
export { default as ArrowDown } from '#/images/svg/arrow-down.svg'
export { default as Cancel } from '#/images/svg/cancel.svg'
export { default as ChevronRight } from '#/images/svg/chevron-right.svg'
export { default as Deposit } from '#/images/svg/circle-arrow-down-left.svg'
export { default as Withdrawal } from '#/images/svg/circle-arrow-up-right.svg'
export { default as ConvertOutline } from '#/images/svg/convert-outline.svg'
export { default as Convert } from '#/images/svg/convert.svg'
export { default as BR } from '#/images/svg/country-br.svg'
export { default as CA } from '#/images/svg/country-ca.svg'
export { default as CN } from '#/images/svg/country-cn.svg'
export { default as GB } from '#/images/svg/country-gb.svg'
export { default as KR } from '#/images/svg/country-kr.svg'
export { default as VN } from '#/images/svg/country-vn.svg'
export { default as EditOutline } from '#/images/svg/edit-outline.svg'
export { default as ExpandMore } from '#/images/svg/expand-more.svg'
export { default as EyeOff } from '#/images/svg/eye-off.svg'
export { default as Eye } from '#/images/svg/eye.svg'
export { default as CustomerService, default as HeadsetMic } from '#/images/svg/headset-mic.svg'
export { default as HomeOutline } from '#/images/svg/home-outline.svg'
export { default as Home } from '#/images/svg/home.svg'
export { default as LogoWithLabel } from './LogoWithLabel'
export { default as LogoWithLabelDark } from './LogoWithLabelDark'
export { default as Logo } from './Logo'
export { default as NotificationsSolid } from '#/images/svg/notifications-solid.svg'
export { default as Notifications } from '#/images/svg/notifications.svg'
export { default as OrderOutline } from '#/images/svg/order-outline.svg'
export { default as Order } from '#/images/svg/order.svg'
export { default as Person } from '#/images/svg/person.svg'
export { default as Scan } from '#/images/svg/scan.svg'
export { default as Spinner } from '#/images/svg/spinner.svg'
export { default as TransformFilled } from '#/images/svg/transform-filled.svg'
export { default as Transform } from '#/images/svg/transform.svg'
export { default as USDT } from '#/images/svg/usdt.svg'
export { default as RMB } from '#/images/svg/rmb.svg'
export { default as UserOutline } from '#/images/svg/user-outline.svg'
export { default as User } from '#/images/svg/user.svg'
export { default as Close } from '#/images/svg/close.svg'
export { default as ScheduleOutline } from '#/images/svg/schedule-outline.svg'
export { default as Send } from '#/images/svg/send.svg'
export { default as CheckCircle } from '#/images/svg/check-circle.svg'
export { default as Error } from '#/images/svg/error.svg'
export { default as Info } from '#/images/svg/info.svg'
export { default as Warning } from '#/images/svg/warning.svg'
export { default as Verified } from '#/images/svg/verified.svg'
export { default as Check } from '#/images/svg/check.svg'
export { default as Download } from '#/images/svg/download.svg'
export { default as ReceiptOff } from '#/images/svg/receipt-off.svg'
export { default as Reviewing } from '#/images/svg/reviewing.svg'
export { default as RecordIllustration } from '#/images/svg/record-illustration.svg'
export { default as Delete } from '#/images/svg/delete.svg'
export { default as Play } from '#/images/svg/play.svg'
export { default as Copy } from '#/images/svg/copy.svg'
export { default as ServerError } from '#/images/svg/server-error.svg'
export { default as UploadImage } from '#/images/svg/upload-image.svg'
export { default as Wallet } from '#/images/svg/wallet.svg'
export { default as QrCode } from '#/images/svg/qr-code-1.svg'
export { default as QrCode2 } from '#/images/svg/qr-code-2.svg'
export { default as IdCard } from '#/images/svg/id-card.svg'
export { default as VideoCall } from '#/images/svg/video-call.svg'
export { default as Upload } from '#/images/svg/upload.svg'
export { default as Camera } from '#/images/svg/camera.svg'
export { default as Image } from '#/images/svg/image.svg'
export { default as Description } from '#/images/svg/description.svg'
export { default as Vip0 } from '#/images/svg/vip-0.svg'
export { default as Vip1 } from '#/images/svg/vip-1.svg'
export { default as Vip2 } from '#/images/svg/vip-2.svg'
export { default as Vip3 } from '#/images/svg/vip-3.svg'
export { default as Vip4 } from '#/images/svg/vip-4.svg'
export { default as Vip5 } from '#/images/svg/vip-5.svg'
export { default as Vip6 } from '#/images/svg/vip-6.svg'
export { default as Vip7 } from '#/images/svg/vip-7.svg'
export { default as Vip8 } from '#/images/svg/vip-8.svg'
export { default as Vip9 } from '#/images/svg/vip-9.svg'
export { default as Vip10 } from '#/images/svg/vip-10.svg'
export { default as BottomRightTriangle } from '#/images/svg/triangle-bottom-right.svg'
export { default as BottomTriangle } from '#/images/svg/triangle-bottom.svg'
export { default as BottomLeftTriangle } from '#/images/svg/triangle-bottom-left.svg'
export { default as TopLeftTriangle } from '#/images/svg/triangle-top-left.svg'
export { default as Ticket } from '#/images/svg/ticket.svg'
export { default as RedEnvelope } from '#/images/svg/red-envelope.svg'
